import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { loadAccountFeature, loadAccountFeaturesFinished } from './account.actions';
import { switchMap, map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { UserAccountService } from '../../../services/user-account.service';
import { FeatureToggleService } from '../../../services/feature-toggle.service';

@Injectable()
export class AccountFeatureEffects {
    private readonly actions$ = inject(Actions);
    private readonly userAccountService = inject(UserAccountService);
    private readonly featureToggleService = inject(FeatureToggleService);

    loadAccountFeatures$ = createEffect(() =>
        this.actions$.pipe(
            ofType(loadAccountFeature),
            switchMap(({ customerId }) =>
                this.userAccountService.getUserAssignFeatures(customerId).pipe(
                    map(accountFeatures => {
                        this.featureToggleService.setAccountFeature(accountFeatures.featureUserAccounts);
                        return loadAccountFeaturesFinished({ accountFeatures });
                    }),
                    catchError(() => of(loadAccountFeaturesFinished({ accountFeatures: null })))
                )
            )
        )
    );
}
